import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { RecoveryComponent } from './recovery/recovery.component';

@NgModule({
	declarations: [RecoveryComponent],
	imports: [SharedModule]
})
export class RecoveryModule {}
